import {
  SubjectDetailsHeader,
  SubjectLessonsSection,
} from "@app/grades/components/SubjectDetails";
import { Breadcrumb } from "@app/shared/components/Breadcrumb";
import { type SubjectWithLessons } from "@core/grades/types";
import { useSubjectDetailsPage } from "../hooks";

type SubjectDetailsPageContentProps = {
  subject: SubjectWithLessons;
};

export function SubjectDetailsPageContent({
  subject,
}: SubjectDetailsPageContentProps) {
  const {
    activeCategoryId,
    breadcrumbs,
    categories,
    filteredLessons,
    handleCategoryChange,
    handleSearchChange,
    searchQuery,
    totalCategories,
    totalLessons,
  } = useSubjectDetailsPage(subject);

  return (
    <div className="app-page-canvas relative isolate overflow-hidden pb-16">
      <div className="dark:from-primary-950/30 pointer-events-none absolute inset-x-0 top-0 -z-10 h-[34rem] bg-gradient-to-b from-primary-50/80 via-violet-50/50 to-transparent dark:via-violet-950/20" />
      <div className="pointer-events-none absolute -start-28 top-56 -z-10 h-72 w-72 rounded-full bg-cyan-200/30 blur-3xl dark:bg-cyan-900/10" />
      <div className="pointer-events-none absolute -end-28 top-16 -z-10 h-80 w-80 rounded-full bg-violet-200/40 blur-3xl dark:bg-violet-900/10" />

      <div className="container mx-auto px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
        <div className="mb-5 sm:mb-7">
          <Breadcrumb items={breadcrumbs} />
        </div>

        <SubjectDetailsHeader
          subject={subject}
          totalCategories={totalCategories}
          totalLessons={totalLessons}
        />

        <SubjectLessonsSection
          activeCategoryId={activeCategoryId}
          categories={categories}
          lessons={filteredLessons}
          searchQuery={searchQuery}
          subjectName={subject.name}
          totalLessons={totalLessons}
          onCategoryChange={handleCategoryChange}
          onSearchChange={handleSearchChange}
        />
      </div>
    </div>
  );
}
